{ "compressionlevel":-1,
 "editorsettings":
    {
     "export":
        {
         "format":"json"
        }
    },
 "height":60,
 "infinite":false,
 "layers":[
        {
         "data":[265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 155, 178, 178, 178, 157, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 243, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 155, 205, 178, 178, 178, 201, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 268, 265, 177, 178, 178, 178, 201, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 179, 265, 265, 265, 265, 246, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 155, 205, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 243, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 199, 183, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 199, 183, 178, 204, 157, 265, 265, 268, 265, 265, 265, 265, 265, 265, 265, 265, 265, 268, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 204, 157, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 199, 183, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 155, 205, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 268, 265, 265, 265, 177, 178, 178, 178, 204, 157, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 266, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 199, 183, 178, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 244, 178, 201, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 155, 205, 178, 178, 201, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 266, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 268, 265, 265, 265, 265, 265, 265, 266, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 199, 200, 200, 201, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1337, 1338, 1338, 1339, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 266, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 245, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 155, 156,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1337, 1338, 1338, 1387, 1360, 1360, 1386, 1338, 1338, 1339, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 155, 156, 205, 178,
            265, 265, 265, 265, 265, 265, 265, 265, 155, 156, 156, 156, 157, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 155, 205, 178, 178, 178,
            265, 265, 265, 265, 268, 265, 155, 156, 205, 178, 178, 178, 204, 157, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 155, 156, 156, 156, 156, 156, 157, 265, 265, 265, 155, 156, 205, 178, 178, 178, 178,
            157, 265, 265, 265, 265, 155, 205, 178, 178, 178, 178, 178, 178, 204, 156, 156, 156, 156, 157, 1337, 1338, 1338, 1338, 1338, 1338, 1387, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1386, 1338, 1338, 1338, 1338, 1338, 1339, 155, 156, 205, 178, 178, 178, 178, 178, 204, 156, 156, 156, 205, 178, 178, 178, 178, 178, 178,
            204, 156, 156, 156, 156, 205, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 179, 1359, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1361, 177, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178,
            178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 179, 1359, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1361, 177, 178, 178, 182, 183, 178, 178, 178, 178, 178, 178, 178, 178, 178, 178, 182, 200, 200, 200,
            178, 178, 178, 178, 178, 178, 182, 200, 200, 200, 200, 183, 178, 178, 182, 200, 200, 200, 201, 1381, 1382, 1382, 1382, 1382, 1382, 1365, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1364, 1382, 1382, 1382, 1382, 1382, 1383, 199, 200, 200, 201, 199, 200, 183, 178, 178, 182, 200, 200, 183, 182, 200, 201, 265, 265, 265,
            200, 183, 178, 178, 182, 200, 201, 265, 265, 265, 265, 199, 200, 200, 201, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 199, 200, 200, 201, 265, 265, 199, 201, 265, 265, 265, 265, 265,
            265, 199, 200, 200, 201, 265, 265, 265, 265, 265, 265, 265, 265, 265, 269, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1381, 1382, 1382, 1365, 1360, 1360, 1364, 1382, 1382, 1383, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 266, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1359, 1360, 1360, 1361, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 1381, 1382, 1382, 1383, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 155, 156, 156, 157, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 178, 157, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 155, 178, 178, 178, 178, 179, 265, 265, 265, 265, 245, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 267, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 178, 182, 201, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 245, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 266, 265, 199, 183, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 269, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 204, 157, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 178, 179, 265, 265, 245, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 267, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 199, 183, 178, 178, 204, 157, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 266, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 155, 178, 178, 178, 178, 204, 157, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 269, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 178, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 178, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 199, 183, 178, 178, 178, 182, 201, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 245, 177, 178, 178, 178, 204, 157, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 199, 183, 178, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 269, 265, 265, 265, 265, 265, 265, 269, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 246, 265, 265, 265, 265, 155, 205, 178, 178, 178, 179, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 245, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 155, 205, 178, 178, 178, 182, 201, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265,
            265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 177, 178, 178, 178, 178, 201, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265, 265],
         "height":60,
         "id":1,
         "name":"floor",
         "opacity":1,
         "type":"tilelayer",
         "visible":true,
         "width":60,
         "x":0,
         "y":0
        }, 
        {
         "data":[573, 574, 0, 610, 611, 589, 590, 0, 0, 625, 626, 627, 628, 609, 610, 611, 589, 590, 0, 625, 626, 627, 628, 625, 626, 627, 628, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 621, 622, 623, 624, 591, 592, 606, 607, 637, 638, 639, 640, 606, 607,
            589, 590, 625, 626, 627, 628, 0, 610, 611, 641, 642, 643, 644, 625, 626, 627, 628, 573, 574, 641, 642, 643, 644, 641, 642, 643, 644, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 637, 638, 639, 640, 0, 621, 622, 623, 624, 0, 0, 621, 622, 623,
            610, 611, 641, 642, 643, 644, 625, 626, 627, 628, 609, 610, 611, 641, 642, 643, 644, 589, 590, 0, 0, 609, 610, 611, 612, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 606, 607, 637, 638, 639, 640, 606, 607, 637, 638, 639,
            626, 627, 628, 0, 610, 611, 641, 642, 643, 644, 625, 626, 627, 628, 0, 579, 580, 609, 610, 611, 612, 625, 626, 627, 628, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 575, 576, 0, 0, 0, 0, 621, 622, 623, 624, 0, 0, 621, 622, 623, 624, 0, 0,
            642, 643, 644, 625, 626, 627, 628, 0, 610, 611, 641, 642, 643, 644, 0, 595, 596, 625, 626, 627, 628, 641, 642, 643, 644, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 591, 592, 0, 0, 575, 576, 637, 638, 639, 640, 606, 607, 637, 638, 639, 640, 606, 607,
            0, 610, 611, 641, 642, 643, 644, 625, 626, 627, 628, 0, 0, 0, 0, 0, 0, 641, 642, 643, 644, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 591, 592, 0, 0, 0, 621, 622, 623, 624, 0, 0, 621, 622, 623,
            625, 626, 627, 628, 0, 610, 611, 641, 642, 643, 644, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 637, 638, 639, 640, 0, 0, 637, 638, 639,
            641, 642, 643, 644, 625, 626, 627, 628, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            610, 611, 0, 0, 641, 642, 643, 644, 0, 0, 0, 0, 0, 0, 0, 0, 0, 705, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 749, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 575, 576, 0, 0, 0, 0,
            626, 627, 628, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 575, 576, 0, 0, 0, 0, 591, 592, 0, 0, 0, 0,
            642, 643, 644, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 591, 592, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 705, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 735, 0, 0, 0, 0, 0, 0, 0, 737, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 703, 704, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 738, 0, 0, 0, 0, 0, 0, 0, 0, 0, 719, 720, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 573, 574, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 573, 574, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 589, 590, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 589, 590, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 742, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 573, 574, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 589, 590, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 573, 574, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 589, 590, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 741, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 751, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 752, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 750, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 755, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 750, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 750, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 736, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 573, 574, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 703, 704, 0, 0, 0, 0, 0, 0, 0, 0, 589, 590, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 573, 574, 0, 719, 720, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 589, 590, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 573, 574, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 750, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 589, 590, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 737, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 703, 704, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 719, 720, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 573, 574, 0, 610, 611, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 742, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 740, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 589, 590, 625, 626, 627, 628, 0, 0, 0,
            0, 0, 0, 0, 573, 574, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 573, 574, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 641, 642, 643, 644, 0, 0, 0,
            0, 0, 0, 0, 589, 590, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 589, 590, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 749, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
         "height":60,
         "id":3,
         "name":"nature",
         "opacity":1,
         "type":"tilelayer",
         "visible":true,
         "width":60,
         "x":0,
         "y":0
        }],
 "nextlayerid":5,
 "nextobjectid":1,
 "orientation":"orthogonal",
 "renderorder":"right-down",
 "tiledversion":"1.10.0",
 "tileheight":16,
 "tilesets":[
        {
         "columns":22,
         "firstgid":1,
         "image":"..\/..\/..\/..\/..\/..\/..\/Desktop\/game-assets\/NinjaAdventure\/Backgrounds\/Tilesets\/TilesetFloor.png",
         "imageheight":417,
         "imagewidth":352,
         "margin":0,
         "name":"TilesetFloor",
         "spacing":0,
         "tilecount":572,
         "tileheight":16,
         "tilewidth":16
        }, 
        {
         "columns":16,
         "firstgid":573,
         "image":"..\/..\/..\/..\/..\/..\/..\/Desktop\/game-assets\/NinjaAdventure\/Backgrounds\/Tilesets\/TilesetNature.png",
         "imageheight":288,
         "imagewidth":256,
         "margin":0,
         "name":"TilesetNature",
         "spacing":0,
         "tilecount":288,
         "tileheight":16,
         "tiles":[
                {
                 "id":0,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":1,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":2,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":3,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":4,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":5,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":6,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":7,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":8,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":9,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":10,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":11,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":12,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":13,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":14,
                 "objectgroup":
                    {
                     "draworder":"index",
                     "name":"",
                     "objects":[
                            {
                             "height":14,
                             "id":1,
                             "name":"",
                             "rotation":0,
                             "type":"",
                             "visible":true,
                             "width":16,
                             "x":0,
                             "y":2
                            }],
                     "opacity":1,
                     "type":"objectgroup",
                     "visible":true,
                     "x":0,
                     "y":0
                    },
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":15,
                 "objectgroup":
                    {
                     "draworder":"index",
                     "name":"",
                     "objects":[
                            {
                             "height":14,
                             "id":1,
                             "name":"",
                             "rotation":0,
                             "type":"",
                             "visible":true,
                             "width":16,
                             "x":0,
                             "y":2
                            }],
                     "opacity":1,
                     "type":"objectgroup",
                     "visible":true,
                     "x":0,
                     "y":0
                    },
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":16,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":17,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":18,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":19,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":20,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":21,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":22,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":23,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":24,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":25,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":26,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":27,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":28,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":29,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":30,
                 "objectgroup":
                    {
                     "draworder":"index",
                     "name":"",
                     "objects":[
                            {
                             "height":15,
                             "id":1,
                             "name":"",
                             "rotation":0,
                             "type":"",
                             "visible":true,
                             "width":16,
                             "x":0,
                             "y":0
                            }],
                     "opacity":1,
                     "type":"objectgroup",
                     "visible":true,
                     "x":0,
                     "y":0
                    },
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":31,
                 "objectgroup":
                    {
                     "draworder":"index",
                     "name":"",
                     "objects":[
                            {
                             "height":15,
                             "id":1,
                             "name":"",
                             "rotation":0,
                             "type":"",
                             "visible":true,
                             "width":16,
                             "x":0,
                             "y":0
                            }],
                     "opacity":1,
                     "type":"objectgroup",
                     "visible":true,
                     "x":0,
                     "y":0
                    },
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":32,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":33,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":34,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":35,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":36,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":37,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":38,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":39,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":40,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":41,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":42,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":43,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":44,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":45,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":46,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":47,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":48,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":49,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":50,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":51,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":52,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":53,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":54,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":55,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":56,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":57,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":58,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":59,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                },
            
                {
                 "id":60,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":61,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":62,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":63,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":64,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":65,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":66,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":67,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":68,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":69,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":70,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":71,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":72,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":73,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":74,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":75,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":76,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":77,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":78,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":79,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":80,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":81,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":82,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":83,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":84,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":85,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":86,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":87,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":88,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":89,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":90,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":91,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":92,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":93,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":94,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":95,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":96,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":97,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":98,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":99,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":100,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":101,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":102,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":103,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":104,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":105,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":106,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":107,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":108,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":109,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":110,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":111,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":112,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":113,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":114,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":115,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":116,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":117,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":118,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":119,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                },
            
                {
                 "id":120,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":121,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":122,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":123,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":124,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":125,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":126,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":127,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":128,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":129,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":130,
                 "objectgroup":
                    {
                     "draworder":"index",
                     "name":"",
                     "objects":[
                            {
                             "height":10,
                             "id":2,
                             "name":"",
                             "rotation":0,
                             "type":"",
                             "visible":true,
                             "width":15,
                             "x":1,
                             "y":6
                            }],
                     "opacity":1,
                     "type":"objectgroup",
                     "visible":true,
                     "x":0,
                     "y":0
                    },
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":131,
                 "objectgroup":
                    {
                     "draworder":"index",
                     "name":"",
                     "objects":[
                            {
                             "height":10,
                             "id":5,
                             "name":"",
                             "rotation":0,
                             "type":"",
                             "visible":true,
                             "width":14,
                             "x":0,
                             "y":6
                            }],
                     "opacity":1,
                     "type":"objectgroup",
                     "visible":true,
                     "x":0,
                     "y":0
                    },
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":132,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":133,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":134,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":135,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":136,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":137,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":138,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":139,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":140,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":141,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":142,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":143,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":144,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":145,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":146,
                 "objectgroup":
                    {
                     "draworder":"index",
                     "name":"",
                     "objects":[
                            {
                             "height":13,
                             "id":12,
                             "name":"",
                             "rotation":0,
                             "type":"",
                             "visible":true,
                             "width":15,
                             "x":1,
                             "y":0
                            }],
                     "opacity":1,
                     "type":"objectgroup",
                     "visible":true,
                     "x":0,
                     "y":0
                    },
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":147,
                 "objectgroup":
                    {
                     "draworder":"index",
                     "name":"",
                     "objects":[
                            {
                             "height":12,
                             "id":4,
                             "name":"",
                             "rotation":0,
                             "type":"",
                             "visible":true,
                             "width":15,
                             "x":0,
                             "y":0
                            }],
                     "opacity":1,
                     "type":"objectgroup",
                     "visible":true,
                     "x":0,
                     "y":0
                    },
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":148,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":149,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":150,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":151,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":152,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":153,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":154,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":155,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":156,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":157,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":158,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":159,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":160,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":161,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":162,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":163,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":164,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":165,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":166,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":167,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":168,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":169,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":170,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":171,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":172,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":173,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":174,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":175,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":176,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":177,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":178,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":179,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                },
            
                {
                 "id":180,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":181,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":182,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":183,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":184,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":185,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":186,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":187,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":188,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":189,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":190,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":191,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":192,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":193,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":194,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":195,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":196,
                 "objectgroup":
                    {
                     "draworder":"index",
                     "name":"",
                     "objects":[
                            {
                             "height":12,
                             "id":1,
                             "name":"",
                             "rotation":0,
                             "type":"",
                             "visible":true,
                             "width":13,
                             "x":3,
                             "y":4
                            }],
                     "opacity":1,
                     "type":"objectgroup",
                     "visible":true,
                     "x":0,
                     "y":0
                    },
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":197,
                 "objectgroup":
                    {
                     "draworder":"index",
                     "name":"",
                     "objects":[
                            {
                             "height":12,
                             "id":9,
                             "name":"",
                             "rotation":0,
                             "type":"",
                             "visible":true,
                             "width":14,
                             "x":0,
                             "y":4
                            }],
                     "opacity":1,
                     "type":"objectgroup",
                     "visible":true,
                     "x":0,
                     "y":0
                    },
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":198,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":199,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":200,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":201,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":202,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":203,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":204,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":205,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":206,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":207,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":208,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":209,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":210,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":211,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":212,
                 "objectgroup":
                    {
                     "draworder":"index",
                     "name":"",
                     "objects":[
                            {
                             "height":15,
                             "id":4,
                             "name":"",
                             "rotation":0,
                             "type":"",
                             "visible":true,
                             "width":14,
                             "x":2,
                             "y":0
                            }],
                     "opacity":1,
                     "type":"objectgroup",
                     "visible":true,
                     "x":0,
                     "y":0
                    },
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":213,
                 "objectgroup":
                    {
                     "draworder":"index",
                     "name":"",
                     "objects":[
                            {
                             "height":15,
                             "id":2,
                             "name":"",
                             "rotation":0,
                             "type":"",
                             "visible":true,
                             "width":15,
                             "x":0,
                             "y":0
                            }],
                     "opacity":1,
                     "type":"objectgroup",
                     "visible":true,
                     "x":0,
                     "y":0
                    },
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":214,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":215,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":216,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":217,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":218,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":219,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":220,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":221,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":222,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":223,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":224,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":225,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":226,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":227,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":228,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":229,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":230,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":231,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":232,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":233,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":234,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":235,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":236,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":237,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":238,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":239,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                },
            
                {
                 "id":240,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":241,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":242,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":243,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":244,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":245,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":246,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":247,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":248,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":249,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":250,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":251,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":252,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":253,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":254,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":255,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":256,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":257,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":258,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":259,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":260,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":261,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":262,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":263,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":264,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":265,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":266,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":267,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":268,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":269,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":270,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }, 
                {
                 "id":271,
                 "properties":[
                        {
                         "name":"collides",
                         "type":"bool",
                         "value":true
                        }]
                }],
         "tilewidth":16
        }, 
        {
         "columns":28,
         "firstgid":861,
         "image":"..\/..\/..\/..\/..\/..\/..\/Desktop\/game-assets\/NinjaAdventure\/Backgrounds\/Tilesets\/TilesetWater.png",
         "imageheight":272,
         "imagewidth":448,
         "margin":0,
         "name":"TilesetWater",
         "spacing":0,
         "tilecount":476,
         "tileheight":16,
         "tilewidth":16
        }, 
        {
         "columns":22,
         "firstgid":1337,
         "image":"..\/..\/..\/..\/..\/..\/..\/Desktop\/game-assets\/NinjaAdventure\/Backgrounds\/Tilesets\/Interior\/TilesetInteriorFloor.png",
         "imageheight":272,
         "imagewidth":352,
         "margin":0,
         "name":"TilesetInteriorFloor",
         "spacing":0,
         "tilecount":374,
         "tileheight":16,
         "tilewidth":16
        }],
 "tilewidth":16,
 "type":"map",
 "version":"1.10",
 "width":60
}